import React, { useContext } from "react"
import PropTypes from "prop-types"
import {Modal, Button, Form } from "react-bootstrap"
import { ModalContext } from "../layout"

function RequestDemoModal() {
  const [showModal, setShowModal] = useContext(ModalContext)
  const handleClose = () => {
    setShowModal(false)
  }

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Request a Demo</Modal.Title>
      </Modal.Header>
      <Form name="Request Demo Form" method="POST" action="/book-a-demo#book-a-zcal-demo">
        <Modal.Body>
          <input type="hidden" name="form-name" value="Request Demo Form" />
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label netlify>Email address</Form.Label>
            <Form.Control
                type="email"
                name="email"
                placeholder="john@example.com"
                required
            />
            <Form.Text className="text-muted">
              <small>We'll never share your email with anyone else.</small>
            </Form.Text>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formFullName">
            <Form.Label>Full name</Form.Label>
            <Form.Control
              type="text"
              name="fullName"
              placeholder="John Doe"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formCompanyName">
            <Form.Label>Company website</Form.Label>
            <Form.Control
              type="url"
              name="company"
              placeholder="https://www.example.com/"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formCompanyRole">
            <Form.Label>Company Role</Form.Label>
            <Form.Control
              type="text"
              name="companyRole"
              placeholder="CEO, Sales, Engineer"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="px-4 mt-3"
            variant="secondary"
            style={{
              borderRadius: "8px",
            }}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
              className="px-4 mt-3"
              type="submit"
              variant="primary"
              style={{
                background: "#1F7ABF",
                borderRadius: "8px",
              }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

RequestDemoModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
}

export default RequestDemoModal
